module.exports = __webpack_public_path__ + "favicon.ico";


/*****************
 ** WEBPACK FOOTER
 ** /mnt/jenkins/jobs/master/workspace/core/client/favicon.ico
 ** module id = 511
 ** module chunks = 0 1 2 3 4 5 7 8 9 10 11
 **/